import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from "moment";
import 'moment/locale/pt-br';

import '../../../node_modules/react-vis/dist/style.css';
import {
  XYPlot,
  XAxis,
  YAxis,
  HorizontalGridLines,
  VerticalBarSeries,
  VerticalGridLines,
  LineMarkSeries,
  DiscreteColorLegend,
  LabelSeries
} from 'react-vis';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';

import { Bar, Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Header from '../../components/Header';
import ModalRegionDashboard from '../../components/modals/ModalRegion';
import ModalRegionRanking from '../../components/modals/ModalRegion';
import ModalShift from '../../components/modals/ModalShift';
import InputDate from '../../components/inputs/InputDate';
import ResponsiveLoading, { Loading, TableLoading } from '../../components/ResponsiveLoading';

import dash from '../../assets/images/dash.svg';
import pin2 from '../../assets/images/pin2.svg';
import br from '../../assets/images/brazil.svg';
import sp from '../../assets/images/sp.svg';
import rj from '../../assets/images/rj.svg';
import plusCircle from '../../assets/images/plusCircle.svg';
import filter from '../../assets/images/filter2.svg';

import trophy from '../../assets/images/trophy.svg';
import trophy2 from '../../assets/images/trophy2.svg';
import trophy4 from '../../assets/images/trophy4.svg';
import api from '../../services/api';
import getUserInfo from "../../services/getUserInfo";
import { createUrlParamsFromObject } from '../../services/helpers';
import ModalRegionTotal from '../../components/modals/ModalRegionTotal';
import ModalShiftTotal from '../../components/modals/ModalShiftTotal';
import { color } from 'chart.js/helpers';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  ChartDataLabels
);

export const Sales = () => {
  const origin = localStorage.getItem('origin');

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  let urlRegionId = urlParams.get('region_id') ?? null;
  let urlRegionNome = urlParams.get('region_nome') ?? null;
  let urlRegionSlug = urlParams.get('region_slug') ?? null;

  const [showRegionsRanking, setShowRegionsRanking] = useState(false);
  const [showRegionsDashboard, setShowRegionsDashboard] = useState(false);
  const [showRegionTotal, setShowRegionTotal] = useState(false);

  const [showShiftsTotal, setShowShiftsTotal] = useState(false);
  const [showShiftsDashboard, setShowShiftsDashboard] = useState(false);

  const [shiftsDashboard, setShiftsDashboard] = useState([]);
  const [shiftsTotal, setShiftsTotal] = useState([]);

  const [totalShiftsDashboard, setTotalShiftsDashboard] = useState(0);
  const [totalShiftsTotal, setTotalShiftsTotal] = useState(0);

  const [saleToday, setSaleToday] = useState(0);
  const [saleMonth, setSaleMonth] = useState(0);
  const [saleWeek, setSaleWeek] = useState(0);
  const [vgvToday, setVgvToday] = useState(0);
  const [vgvMonth, setVgvMonth] = useState(0);
  const [vgvWeek, setVgvWeek] = useState(0);
  const [totalVendas, setTotalVendas] = useState(0);
  const [totalVGV, setTotalVGV] = useState(0);
  const [totalVendasObjeto, setTotalVendasObjeto] = useState([]);
  const [lastSales, setLastSales] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [corretores, setCorretores] = useState([]);
  const [gerentes, setGerentes] = useState([]);
  const [superintendentes, setSuperintendentes] = useState([]);
  const [regionDashboard, setRegionDashboard] = useState({});
  const [regionRanking, setRegionRanking] = useState({});
  const [regionTotal, setRegionTotal] = useState({});
  const [filterDashboard, setFilterDashboard] = useState({});
  const [filterRanking, setFilterRanking] = useState({});
  const [filterTotal, setFilterTotal] = useState({});
  const [startDate, setStartDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  const [startDateTotal, setStartDateTotal] = useState('');
  const [finalDateTotal, setFinalDateTotal] = useState('');

  const [loadingResumoVendas, setLoadingResumoVendas] = useState(true);
  const [loadingRankingVendas, setLoadingRankingVendas] = useState(true);
  const [loadingShifts, setLoadingShifts] = useState(true);
  const [loadingTotalVendas, setLoadingTotalVendas] = useState(true);
  const [loadingShiftsTotal, setLoadingShiftsTotal] = useState(true);

  const [userInfo, setUserInfo] = useState({});
  const [userCanSeeVGV, setUserCanSeeVGV] = useState(true);

  const [hour, setHour] = useState('');

  const [icon] = useState({
    'br': br,
    'sp': sp,
    'rj': rj
  });

  useEffect(() => {
    getUserInfo().then(user => {
      setUserInfo(user);
      // setUserCanSeeVGV(user.isDiretor || user.isMaster || user.isSuperintendente);
    });
  }, []);

  useEffect(() => {
    window.handleRegion = (id, nome, slug) => {
      let region = { id, nome, slug };
      handleRegion(region, 'dashboard');
      handleRegion(region, 'ranking');
      handleRegion(region, 'total');
    };

    let date = new Date();

    setStartDate(date);
    setFinalDate(date);

    setStartDateTotal(date);
    setFinalDateTotal(date);
 
    let filters = {
      date_start: moment(date).format('YYYY-MM-DD'),
      date_end: moment(date).format('YYYY-MM-DD'),
      regional_id: urlRegionId
    }

    let filtersDashboard = {
      regional_id: urlRegionId
    };

    
    setFilterRanking(filters);

    getShifts(urlRegionId);

    let region = {
      id: urlRegionId,
      nome: urlRegionNome ?? 'Brasil',
      slug: urlRegionSlug ?? 'br'
    };

    setRegionDashboard(region);
    setRegionRanking(region);
    setRegionTotal(region);

    getResumoVendas(filtersDashboard);
    getTotalVendas(filters);
    getRankingVendas(filters);

    setFilterDashboard(filtersDashboard);
    setFilterRanking(filters);
  }, []);

  const getResumoVendas = async (filters = {}) => {
    setLoadingResumoVendas(true);
    const { data, status } = await api.get(`vendas/resumo`, {
      params: filters
    });
    if (status === 200) {
      setSaleToday(data.total_vendas.hoje);
      setSaleMonth(data.total_vendas.mes);
      setSaleWeek(data.total_vendas.semana);
      setVgvToday(data.total_vendas.totalVGVHoje);
      setVgvWeek(data.total_vendas.totalVGVSemana);
      setVgvMonth(data.total_vendas.totalVGVMes);
      setLastSales(data.total_vendas.ultimos_dias);
      setTopProducts(data.top_produtos);
      setLoadingResumoVendas(false);
      setHour(moment().format('LT'));
    }
  }

  const getTotalVendas = async (filters = {}) => {
    setLoadingTotalVendas(true);
    const { data, status } = await api.get(`vendas/total`, {
      params: filters
    });
    if (status === 200) {
      setTotalVendas(data.total_vendas);
      setTotalVGV(data.total_vgv);
      setTotalVendasObjeto(data.total_vendas_resource);
      setHour(moment().format('LT'));
      setLoadingTotalVendas(false);
    }
  }

  const getRankingVendas = async (filters = {}) => {
    setLoadingRankingVendas(true);

    // aplicar filtro de 1 dia
    if( !(filters.date_start || null) ){
      filters.date_start = moment().format('YYYY-MM-DD');
      filters.date_end = moment().format('YYYY-MM-DD');
    }

    const { data, status } = await api.get(`vendas/ranking`, {
      params: filters
    });
    if (status === 200) {
      setCorretores(data.corretores);
      setGerentes(data.gerentes);
      setSuperintendentes(data.superintendentes);
      setLoadingRankingVendas(false);
      setHour(moment().format('LT'));
    }
  }

  const handleRegion = (region, typeRegion) => {
    let filter = {};

    switch (typeRegion) {
      case 'dashboard':
        setRegionDashboard(region);
        setShowRegionsDashboard(false);
        filter = filterDashboard;
        filter.regional_id = region.id;
        filter.plantoes_ids = [];
        getShifts(region.id, setShiftsDashboard, setTotalShiftsDashboard);
        setFilterDashboard(filter);
        getResumoVendas(filter);
        break;

      case 'total':
        setRegionTotal(region);
        setShowRegionTotal(false);
        filter = filterTotal;
        filter.regional_id = region.id;
        filter.plantoes_ids = [];
        getShifts(region.id, setShiftsTotal, setTotalShiftsTotal);
        setFilterTotal(filter);
        getTotalVendas(filter);
        break;

      case 'ranking':
        setRegionRanking(region);
        setShowRegionsRanking(false);
        filter = filterRanking;
        filter.regional_id = region.id;
        setFilterRanking(filter);
        getRankingVendas(filter);
        break;
    }
  }

  const handleShiftDashboard = (shifts, allShifts) => {
    /* console.log(shifts) */
    setShowShiftsDashboard(false);
    /* let filter = filterDashboard; */
    const allSelected =
      shifts.length === allShifts.length &&
      allShifts.every(id => shifts.includes(id));

    const newFilter = { ...filterTotal };

    if (!allSelected) {
      newFilter.plantoes_ids = shifts.join(',');
    } else {
      delete newFilter.plantoes_ids; 
    }
    setShiftsDashboard(shifts);
    
    setFilterDashboard(newFilter);
  }

  const handleShiftTotal = (selectedShifts, allShifts) => {
    setShowShiftsTotal(false);
    setShiftsTotal(selectedShifts);

    const allSelected =
      selectedShifts.length === allShifts.length &&
      allShifts.every(id => selectedShifts.includes(id));

    const newFilter = { ...filterTotal };

    if (!allSelected) {
      newFilter.plantoes_ids = selectedShifts.join(',');
    } else {
      delete newFilter.plantoes_ids; 
    }

    setFilterTotal(newFilter);
  };

  const handleDateTotal = (start, final) => {
    let filter = filterTotal;
    filter.date_start = moment(start).format('YYYY-MM-DD');
    filter.date_end = moment(final).format('YYYY-MM-DD');
    setFilterTotal(filter);
    setStartDateTotal(start);
    setFinalDateTotal(final);
  }

  const handleDate = (start, final) => {
    let filter = filterRanking;
    filter.date_start = moment(start).format('YYYY-MM-DD');
    filter.date_end = moment(final).format('YYYY-MM-DD');
    setFilterRanking(filter);
    getRankingVendas(filterRanking);
    setStartDate(start);
    setFinalDate(final);
  }

  const formatarVGV = (centavos) => {
    const numero = centavos / 100;
  
    if (numero >= 1_000_000_000) {
      return `${(numero / 1_000_000_000).toFixed(1).replace('.', ',')} bi`;
    } 
    
    if (numero >= 1_000_000) {
      return `${(numero / 1_000_000).toFixed(1).replace('.', ',')} mi`;
    }

    if (numero >= 1_000) {
      return `${(numero / 1_000).toFixed(1).replace('.', ',')} k`;
    }

    return numero.toLocaleString('pt-BR');
    
  }
  
  const getShifts = async (regionId = null, setShifts, setTotalShifts) => {
    const shiftsFilter = { ...filter };
    delete shiftsFilter.date_start;
    delete shiftsFilter.date_end;
  

    setLoadingShifts(true);

    const { data, status } = await api.get(`list-plantoes`, {
      params: {
        reginal_id: regionId
      }
    });

    let totalShifts = 0;
    let shifts = [];

    data.regionais.map(regional => {
      if(regionId !== null && regional.id !== regionId) return;

      totalShifts += regional.plantoes.length;
      regional.plantoes.map(plantao => {
        shifts.push(plantao.id);
      });
    });

    if (typeof setShifts === 'function'){
      setShifts(shifts);
    } else {
      setShiftsDashboard(shifts);
      setShiftsTotal(shifts);
    }

    if (typeof setTotalShifts === 'function'){
      setTotalShifts(totalShifts);
    } else {
      setTotalShiftsDashboard(totalShifts);
      setTotalShiftsTotal(totalShifts);
    }

    if (status === 200) {
      setLoadingShifts(false);
      setLoadingShiftsTotal(false);
    }
  }

  const labelData = lastSales.map((sale) => ({
    x: moment(sale.date).format('ddd').toUpperCase() + " " + moment(sale.date).format('DD/MM'),
    y: sale.vendas
  }));

  const labels = labelData.map(item => item.x);
  const salesData = labelData.map(item => item.y);

  const data = {
    labels,
    datasets: [
      {
        type: 'bar',
        label: 'Vendas',
        data: salesData,
        backgroundColor: '#90B0C0',
        hoverBackgroundColor: '#2D719F',
        barPercentage: 0.4,
        order: 2,
        datalabels: {
          anchor: 'end',
          align: 'start',
          offset: -20,
          color: '#62829A',
          font: {
            weight: 'bold',
          },
          formatter: (value) => value,
        },
      },
      // {
      //   type: 'line',
      //   label: 'Vendas',
      //   data: salesData,
      //   borderColor: '#4EA1CC',
      //   borderWidth: 2,
      //   pointBackgroundColor: '#4EA1CC',
      //   tension: 0.4,
      //   order: 1,
      //   datalabels: {
      //     align: 'bottom',
      //     color: '#FFF',
      //     font: {
      //       weight: 'bold',
      //     },
      //     formatter: (value) => value,
      //   },
      // },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        max: Math.max(...salesData) + 10,
        grid: {
          display: false,
        },
      },
    },
  };

  const dataMobile = {
    labels,
    datasets: [
      {
        label: 'Vendas',
        data: salesData,
        backgroundColor: '#90B0C0'
      },
    ],
  };

  const optionsMobile = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: '#FFFFFF',
        anchor: 'center',
        align: 'center',
        font: {
          size: 12,
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => `Vendas: ${context.raw}`,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          font: {
            size: 10,
          },
        },
        grid: {
          display: false,
        },
      },
    },
  };

  const goToMore = perfil => {
    let params = {
      sort_by: 'vendas',
      sort_dir: 'desc',
      start_date: moment(startDate).format('YYYY-MM-DD'),
      final_date: moment(finalDate).format('YYYY-MM-DD'),
    };

    if(Object.keys(regionRanking).length > 0){
      params.region_id = regionRanking.id;
      params.region_nome = regionRanking.nome;
      params.region_slug = regionRanking.slug;
    }

    let urlParams = createUrlParamsFromObject(params);

    return `${perfil}?${urlParams}`;
  }

  const update = () => {
    getRankingVendas(filterRanking);
    getResumoVendas(filterDashboard);
  }

  const updateTotal = () => {
    getTotalVendas(filterTotal)
  }

  const getShowMoreUrl = filtro => {
    const hoje = new Date();
    let inicio, fim;
    let url =  '/sales/details';

    switch (filtro) {
      case "dia":
        inicio = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        fim = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        break;
      case "semana":
        const primeiroDiaSemana = hoje.getDate() - hoje.getDay() + 1;
        inicio = new Date(hoje.getFullYear(), hoje.getMonth(), primeiroDiaSemana);
        fim = new Date(hoje.getFullYear(), hoje.getMonth(), primeiroDiaSemana + 6);
        break;
      case "mes":
        inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
        break;
    }

    url = `${url}?start_date=${moment(inicio).format('YYYY-MM-DD')}&final_date=${moment(fim).format('YYYY-MM-DD')}`;
    
    if (filterDashboard.plantoes_ids) {
      url += `&plantoes_ids=${filterDashboard.plantoes_ids}`;
    }

    /* if (shiftsDashboard.length > 0){
      url = `${url}&plantoes_ids=${shiftsDashboard.join(',')}`;
    } */

    return `${url}&region_id=${regionDashboard.id}&region_nome=${regionDashboard.nome}&region_slug=${regionDashboard.slug}`;
  }

  const getShowMoreUrlTotal = () => {
    let filter = filterTotal;
    let inicio = filter.date_start;
    let fim = filter.date_end;

    let url =  '/sales/details';

    url = `${url}?start_date=${moment(inicio).format('YYYY-MM-DD')}&final_date=${moment(fim).format('YYYY-MM-DD')}`;
    console.log(filterDashboard);

    if (filterDashboard.plantoes_ids) {
      url += `&plantoes_ids=${filterDashboard.plantoes_ids}`;
    }

    /* if(shiftsTotal.length > 0 && shiftsTotal.length !== totalShiftsTotal){
      url = `${url}&plantoes_ids=${shiftsTotal.join(',')}`;
    } */

    return url;
  }

  return (
    <>
      {showRegionsRanking &&
        <ModalRegionRanking handleClose={() => setShowRegionsRanking(false)} handleRegion={(region) => handleRegion(region, 'ranking')} />
      }
      {showRegionsDashboard &&
        <ModalRegionDashboard handleClose={() => setShowRegionsDashboard(false)} handleRegion={(region) => handleRegion(region, 'dashboard')} />
      }
      {showShiftsDashboard &&
        <ModalShift 
          region={regionDashboard} 
          handleClose={() => setShowShiftsDashboard(false)} 
          handleShift={handleShiftDashboard} 
          shifts={shiftsDashboard} 
        />
      }
      {showRegionTotal &&
        <ModalRegionTotal handleClose={() => setShowRegionTotal(false)} handleRegion={(region) => handleRegion(region, 'total')} />
      }
      {showShiftsTotal &&
        <ModalShiftTotal region={regionTotal} handleClose={() => setShowShiftsTotal(false)} handleShift={handleShiftTotal} shifts={shiftsTotal} />
      }

      <section id="content">
        <Header icon={<img src={trophy2} />} title="Vendas" showBeta={false} />
        <>
        <div className="pd-37">
          {/* {userCanSeeVGV && 
            <div className="box-alert">
              <p>Informamos que esta área passou por atualizações e encontra-se em fase Beta. A partir do dia 03/12/2024, apresentaremos o VGV juntamente com os dados de vendas. Caso identifique qualquer divergência, solicitamos que entre em contato com o time de Vendas Digitais.</p>
            </div> 
          } */}
          <div className="box light-grey">
            <div className="box-header">
              <div className="box-title">
                <img src={trophy4} />
                <div className="box-title-text">
                  <h2>Vendas</h2>
                  <span>Última atualização: {hour}</span>
                </div>
              </div>
              <div className="box-tools">

                {userInfo.isMaster && origin !== 'app' &&
                <button className="btn-filter" style={{minWidth: 180}} onClick={() => setShowRegionsDashboard(true)}>
                  {loadingShifts &&
                  <Loading cWidth={120} cHeight={40}/>
                  }
                  {!loadingShifts &&
                  <>
                    <img src={icon[regionDashboard.slug] ?? br}/>
                    <span>{regionDashboard.nome ?? 'Brasil'}</span>
                  </>
                  }
                </button>
                }

                <button className="btn-filter" style={{ minWidth: 250 }} onClick={() => setShowShiftsDashboard(true)}>
                  {loadingShifts &&
                    <Loading cWidth={120} cHeight={40} />
                  }
                  {!loadingShifts &&
                    <>
                      <img src={pin2} />
                      <span> {shiftsDashboard.length === totalShiftsDashboard ? `Todos os plantões` : `${shiftsDashboard.length}  Produtos Selecionados`}</span>
                    </>
                  }

                </button>
                <button className="btn-update" onClick={update}>Atualizar</button>
              </div>
            </div>
            <div className="box-body">
              <Row>
                <Col sm={12}>
                  <Row>
                    <Col sm={4}>
                      <div className="box-card mb-0 mb-m-20">
                        <div className="box-card-header center dark-blue">
                          <h3>Hoje</h3>
                        </div>
                        <div className="box-card-body box-card-body-pd">
                          <div className="group-count">
                            {loadingResumoVendas &&
                              <Loading cWidth={100} cHeight={48} />
                            }
                            {!loadingResumoVendas &&
                            <>
                              <span className="p-unity"><span className="n-count">{saleToday.toLocaleString('pt-BR')}</span>unidades</span>
                              {userCanSeeVGV &&
                                <div className="box-value-sales">
                                  <h4><span>R$</span>{formatarVGV(vgvToday)}</h4>
                                </div>
                              }
                            </>
                            }
                            <a href={getShowMoreUrl('dia')}>
                              Ver mais
                            </a>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="box-card mb-0 mb-m-20">
                        <div className="box-card-header center medium-blue">
                          <h3>Esta semana</h3>
                        </div>
                        <div className="box-card-body box-card-body-pd">
                          <div className="group-count">
                            {loadingResumoVendas &&
                              <Loading cWidth={100} cHeight={48} />
                            }
                            {!loadingResumoVendas &&
                            <>
                              <span className="p-unity"><span className="n-count">{saleWeek.toLocaleString('pt-BR')}</span>unidades</span>
                              {userCanSeeVGV &&
                                <div className="box-value-sales">
                                  <h4><span>R$</span>{formatarVGV(vgvWeek)}</h4>
                                </div>
                              }
                            </>
                            }
                            <a href={getShowMoreUrl('semana')}>
                              Ver mais
                            </a>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="box-card mb-0 mb-m-20">
                        <div className="box-card-header center light-blue">
                          <h3>Este mês</h3>
                        </div>
                        <div className="box-card-body box-card-body-pd">
                          <div className="group-count">
                            {loadingResumoVendas &&
                              <Loading cWidth={100} cHeight={48} />
                            }
                            {!loadingResumoVendas &&
                            <>
                              <span className="p-unity"><span className="n-count">{saleMonth.toLocaleString('pt-BR')}</span>unidades</span>
                              {userCanSeeVGV && 
                                <div className="box-value-sales">
                                  <h4><span>R$</span>{formatarVGV(vgvMonth)}</h4>
                                </div>
                              }
                            </>
                            }
                            <a href={getShowMoreUrl('mes')}>
                              Ver mais
                            </a>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="box-card box-card-mt">
                        <div className="box-card-body">
                          <h3>Contratos assinados - Últimos 7 dias</h3>
                          {loadingResumoVendas &&
                            <Loading cWidth={`100%`} cHeight={200} />
                          }
                          {!loadingResumoVendas &&
                            // <XYPlot
                            //   width={910}
                            //   height={230}
                            //   className="chart-dash"
                            //   xType="ordinal"
                            //   stackBy="y"
                            // >
                            //   <XAxis />
                            //   <YAxis />
                            //   <VerticalBarSeries data={labelData} barWidth={0.4} color="#90B0C0" />
                            //   <LineMarkSeries data={labelData} color="#4EA1CC" />
                            //   <LabelSeries data={labelData} getLabel={d => d.y} />
                            // </XYPlot>
                            <>
                            <div className="hide-mobile" style={{ width: '100%', height: '250px' }}>
                              <Bar data={data} options={options} />
                            </div>

                            <div className="show-mobile" style={{ width: '100%', height: '250px' }}>
                              <Bar data={dataMobile} options={optionsMobile} />
                            </div>
                            </>
                          }

                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>

          <div className="box box-border">
            <div className="box-header">
              <div className="box-title">
                <img src={filter} style={{width: 23}} />
                <div className="box-title-text">
                  <h2>Filtros personalizados</h2>
                </div>
              </div>
            </div>
            <div className="box-body">
              <Row>
                <Col sm={4}>
                  <div>
                    {userInfo.isMaster && origin !== 'app' &&
                      <button className="btn-filter btn-box-shadow mb-20 w-full" style={{minWidth: 180}} onClick={() => setShowRegionTotal(true)}>
                        {loadingShiftsTotal &&
                        <Loading cWidth={120} cHeight={40}/>
                        }
                        {!loadingShiftsTotal &&
                        <>
                          <img src={icon[regionTotal.slug] ?? br}/>
                          <span>{regionTotal.nome ?? 'Brasil'}</span>
                        </>
                        }
                      </button>
                    }
                    <button className="btn-filter btn-box-shadow mb-20 w-full" style={{ minWidth: 250 }} onClick={() => setShowShiftsTotal(true)}>
                      {loadingShiftsTotal &&
                        <Loading cWidth={120} cHeight={40} />
                      }
                      {!loadingShiftsTotal &&
                        <>
                          <img src={pin2} />
                          <span> {shiftsTotal.length === totalShiftsTotal ? `Todos os produtos` : `${shiftsTotal.length}  Produtos Selecionados`}</span>
                        </>
                      }
                    </button>
                    <InputDate className={`btn-filter btn-box-shadow mb-20`} cStartDate={startDateTotal} cFinalDate={finalDateTotal} handleDate={handleDateTotal} />
                    <div className="box-tools">
                      <button className="btn-update-total" style={{minWidth: 220, justifyContent: "center"}} onClick={updateTotal}>Atualizar</button>
                    </div>
                    <div className="box-card mb-0 mb-m-20">
                      <div className="box-card-header center light-blue">
                        <h3>Total de vendas</h3>
                      </div>
                      <div className="box-card-body box-card-body-pd">
                        <div className="group-count">
                          {loadingTotalVendas &&
                            <Loading cWidth={100} cHeight={48} />
                          }
                          {!loadingTotalVendas &&
                          <>
                            <span className="p-unity"><span className="n-count">{totalVendas.toLocaleString('pt-BR')}</span>unidades</span>
                            {userCanSeeVGV &&
                              <div className="box-value-sales">
                                <h4><span>R$</span>{formatarVGV(totalVGV)}</h4>
                              </div>
                            }
                          </>
                          }
                          <a href={getShowMoreUrlTotal()}>
                            Ver mais
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col sm={8}>
                  <div className="box-card h-full mb-0">
                    <div className="box-card-sales">
                      <table className="table-dash">
                        <thead>
                          <tr className="light-blue">
                            <th style={ userCanSeeVGV ? {width:'40%'} : {width: '50%'}}>Produto</th>
                            <th style={ userCanSeeVGV ? {width:'30%'} : {width: '50%'}}>Vendas<br/>(Quantidade)</th>
                            {userCanSeeVGV &&
                              <th style={{ width: '30%' }}>Vendas<br/>(VGV)</th>
                            }
                          </tr>
                        </thead>
                        <tbody className="pd-right"> 
                          {loadingTotalVendas &&
                            <tr>
                              <td colSpan={userCanSeeVGV ? 3 : 2}>Carregando...</td>
                            </tr>
                          }
                          {!loadingTotalVendas && totalVendasObjeto.map((vendaObjeto, key) => (
                            <tr key={key}>
                              <td style={ userCanSeeVGV ? {width:'40%'} : {width: '50%'}}>{vendaObjeto.imovel_nome}</td>
                              <td style={ userCanSeeVGV ? {width:'30%'} : {width: '50%'}}>{vendaObjeto.vendas}</td>
                              {userCanSeeVGV &&  
                                <td style={{ width: '30%' }}>R$ {formatarVGV(vendaObjeto.totalVGV)}</td>
                              }
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="box dark-blue">
            <div className="box-header">
              <div className="box-title">
                <img src={trophy} />
                <h2>Ranking de vendas</h2>
              </div>
              <div className="box-tools">

                {userInfo.isMaster && origin !== 'app' &&
                <button className="btn-filter" style={{minWidth: 180}} onClick={() => setShowRegionsRanking(true)}>
                  {loadingShifts &&
                  <Loading cWidth={120} cHeight={40}/>
                  }
                  {!loadingShifts &&
                  <>
                    <img src={icon[regionRanking.slug] ?? br}/>
                    <span>{regionRanking.nome ?? 'Brasil'}</span>
                  </>
                  }
                </button>
                }

                <InputDate cStartDate={startDate} cFinalDate={finalDate} handleDate={handleDate} />
              </div>
            </div>
            <div className="box-body">
              <Row>
                <Col sm={4}>
                  <div className="box-card h-full">
                    <div className="box-card-header light-blue">
                      <h3>Top 5 corretores</h3>
                    </div>
                    <div className="box-card-body">
                      {loadingRankingVendas &&
                        <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                      }
                      {!loadingRankingVendas &&
                        <table className="table-dash">
                          <thead>
                            <tr>
                              <th>Corretor</th>
                              <th>Gerente</th>
                              <th>Assinaturas</th>
                            </tr>
                          </thead>
                          <tbody>
                            {corretores.map((corretor, key) => (
                              <tr key={key}>
                                <td>{corretor.apelido}</td>
                                <td>{corretor?.gerente?.apelido ?? ''}</td>
                                <td>{corretor.total.vendas}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      }
                      {!loadingRankingVendas && corretores.length > 0 &&
                        <a href={`${goToMore('brokers')}`}>
                          <img src={plusCircle} />
                          Ver mais
                        </a>
                      }
                    </div>
                  </div>
                </Col>

                {!userInfo.isGerente && gerentes !== null &&
                <Col sm={4}>
                  <div className="box-card h-full">
                    <div className="box-card-header light-blue">
                      <h3>Top 5 gerentes</h3>
                    </div>
                    <div className="box-card-body">
                      {loadingRankingVendas &&
                      <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300}/>
                      }
                      {!loadingRankingVendas &&
                      <table className="table-dash">
                        <thead>
                        <tr>
                          <th>Gerente</th>
                          <th>Sup</th>
                          <th>Assinaturas</th>
                        </tr>
                        </thead>
                        <tbody>
                        {gerentes.map((gerente, key) => (
                            <tr key={key}>
                              <td>{gerente.apelido}</td>
                              <td>{gerente?.superintendente?.apelido ?? ''}</td>
                              <td>{gerente.total.vendas}</td>
                            </tr>
                        ))}
                        </tbody>
                      </table>
                      }
                      {!loadingRankingVendas && gerentes.length > 0 &&
                        <a href={`${goToMore('managers')}`}>
                          <img src={plusCircle} />
                          Ver mais
                        </a>
                      }
                    </div>
                  </div>
                </Col>
                }

                {(userInfo.isDiretor || userInfo.isUserEspecial) && superintendentes !== null &&
                <Col sm={4}>
                  <div className="box-card h-full">
                    <div className="box-card-header light-blue">
                      <h3>Top 5 superintendentes</h3>
                    </div>
                    <div className="box-card-body">
                      {loadingRankingVendas &&
                      <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300}/>
                      }
                      {!loadingRankingVendas &&
                      <table className="table-dash">
                        <thead>
                        <tr>
                          <th>Sup</th>
                          <th>Diretor</th>
                          <th>Assinaturas</th>
                        </tr>
                        </thead>
                        <tbody>
                        {superintendentes.map((superintendente, key) => (
                            <tr key={key}>
                              <td>{superintendente.apelido}</td>
                              <td>{superintendente?.diretor?.apelido ?? ''}</td>
                              <td>{superintendente.total.vendas}</td>
                            </tr>
                        ))}
                        </tbody>
                      </table>
                      }
                      {!loadingRankingVendas && superintendentes.length > 0 &&
                        <a href={`${goToMore('super')}`}>
                          <img src={plusCircle} />
                          Ver mais
                        </a>
                      }
                    </div>
                  </div>
                </Col>
                }
              </Row>
            </div>
          </div>
        </div>
        </>
      </section>
    </>
  );

}

export default Sales;